import { createActionThunk } from 'redux-thunk-actions';

import {
  FETCH_CGU_CONTENT,
  UPDATE_CGU_CONTENT,
} from '../types/cguContentTypes';
import CguContentService from '../../../services/cguContent';

export const fetchCguContent = createActionThunk(FETCH_CGU_CONTENT, () =>
  CguContentService.fetchCguContent().then((data) => data),
  false,
);

export const updateCguContent = createActionThunk(UPDATE_CGU_CONTENT, (data) =>
  CguContentService.updateCguContent(data).then((res) => res),
  false,
);
